import React, { Component } from 'react';
import { CardElement, injectStripe } from 'react-stripe-elements';
import { Alert } from 'antd';
import { Billing } from '../services/api';

class CheckoutForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: {
                declined: false,
                error: false
            }
        };

        this.billingApi = new Billing(props);
    }

    submit = () => {
        this.props.onLoading();
        this.props.stripe.createToken({ name: 'Token' })
            .then(res => {
                const data = {
                    token: res.token.id
                };
                
                if (this.props.billing) {
                    this.updateCard(data);
                    return;
                }
                this.createCard(data);
            });
    }

    createCard = (data) => {
        this.billingApi.createCard(data)
            .then(() => {
                const { error } = this.state;
                error.error = false;
                error.declined = false;
                this.setState({ error });

                this.props.onSuccess()
            })
            .catch(err => {
                this.billingApi.retry({ params: [data], cb: this.createCard });
                if (err.response && err.response.status === 409) {
                    this.props.onSuccess();
                    return
                } else if (err.response && err.response.status !== 401) {
                    const { error } = this.state;
                    if (err.response.data.error === 'Card declined') {
                        error.declined = true;
                    } else {
                        error.error = true;
                    }
                    this.setState({ error });
                    this.props.onError();
                }
            });
    }

    updateCard = (data) => {
        const { billing } = this.props;
        this.billingApi.raw().put(billing._links['update-card'].href, data)
            .then(() => {
                const { error } = this.state;
                error.error = false;
                error.declined = false;
                this.setState({ error });

                this.props.onSuccess()
            })
            .catch(err => {
                this.billingApi.retry({ params: [data], cb: this.updateCard });
                if (err.response && err.response.status === 409) {
                    this.props.onSuccess();
                    return
                } else if (err.response && err.response.status !== 401) {
                    const { error } = this.state;
                    if (err.response.data === 'Card declined') {
                        error.declined = true;
                    } else {
                        error.error = true;
                    }
                    this.setState({ error });
                    this.props.onError();
                }
            });
    }

    handleChange = (e) => {
        if (e.complete) {
            this.submit();
        }
    }

    render() {
        const { error } = this.state;
        return (
            <div>
                {error.error && (
                    <Alert
                        style={{marginBottom: '20px'}}
                        message="Någonting gick fel när vi skulle lägga till ditt kort. Var vänlig prova igen."
                        type="error"
                        showIcon
                    />
                )}
                {error.declined && (
                    <Alert
                        style={{marginBottom: '20px'}}
                        message="Vi kunde inte debitera ditt kort."
                        type="error"
                        showIcon
                    />
                )}

                <CardElement onChange={this.handleChange} />
            </div>
        );
    }
}

export default injectStripe(CheckoutForm);



// WEBPACK FOOTER //
// ./src/components/CheckoutForm.js